export default __webpack_public_path__ + "static/media/7_virtual ideate.c8a0d7e7.jpg";